import React, { useRef, useState } from 'react';
import axiosInstance from '../../../services/AxiosInstance';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import GoBackButton from '../../../components/GoBackButton';

function Changepasswordpage() {

    const [input, setInput] = useState({ match_pass: false });
    const [newPass, setNewPass] = useState(false);
    const [conPass, setConPass] = useState(false);
    const [passLength, setPassLength] = useState(false);
    const [, forceUpdate] = useState();
    const simpleValidator = useRef(new SimpleReactValidator());

    const handleSubmit = () => {
        const formValid = simpleValidator.current.allValid();
        if (!formValid) {
            simpleValidator.current.showMessages();
            forceUpdate(1);
        } else if (input?.new_password < 6) {
            setPassLength(true);
            setInput({ ...input, "match_pass": false });
        } else if (!(input?.new_password === input?.con_password)) {
            setInput({ ...input, "match_pass": true });
            setPassLength(false);
        } else {
            setPassLength(false);
            setInput({ ...input, "match_pass": false });
            var data = {
                "old_password": input?.old_password,
                "new_password": input?.new_password
            }
            axiosInstance(
                "change_password/", {
                method: "PUT",
                data: data
            }).then(res => {
                if (res?.status === 200) {
                    swal("", res.data.detail, "success", { button: "Ok!", });
                    setInput()
                }
            }).catch(err => {
                console.log('err: ', err.response.data);
                swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
            })
        }
    }

    const handleInput = (e) => {
        setInput({ ...input, [e.target.name]: e.target.value })
    }

    return (
        <div className="job-bx job-profile">
            <div className="job-bx-title clearfix">
                <h5 className="font-weight-700 pull-left text-uppercase">Change Password</h5>
                <GoBackButton />
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="form-group">
                        <label>Old Password <span className="text-danger font-weight-bold">*</span></label>
                        <input
                            type="password"
                            name="old_password"
                            value={input?.old_password || ""}
                            className="form-control cp"
                            onKeyPress={(e) => e.target.value.length >= 30 && e.preventDefault()}
                            onChange={(e) => handleInput(e)}
                        />
                        <span className="text-danger font-weight-bold">
                            {simpleValidator.current.message("old password", input?.old_password, "required")}
                        </span>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-group">
                        <label>New Password <span className="text-danger font-weight-bold">*</span></label>
                        <div className="input-group">
                            <input
                                type={newPass ? "text" : "password"}
                                className="change-password form-control mr-0"
                                name="new_password"
                                onKeyPress={(e) => e.target.value.length >= 30 && e.preventDefault()}
                                value={input?.new_password || ""}
                                onChange={(e) => handleInput(e)}
                            />
                            <div className="change-password input-group-text" style={{ cursor: "pointer" }} onClick={() => setNewPass(!newPass)}>
                                <i className="fa fa-eye" />
                            </div>
                        </div>
                        <span className="text-danger font-weight-bold">
                            {simpleValidator.current.message("new password", input?.new_password, "required")}
                        </span>
                        {passLength?.newPass && <div className="text-danger fs-12">"Password must be minimum 6 characters"</div>}
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-group">
                        <label>Confirm New Password <span className="text-danger font-weight-bold">*</span></label>
                        <div className="input-group">
                            <input
                                type={conPass ? "text" : "password"}
                                className="change-password form-control mr-0"
                                name="con_password"
                                onKeyPress={(e) => e.target.value.length >= 30 && e.preventDefault()}
                                value={input?.con_password || ""}
                                onChange={(e) => handleInput(e)}
                            />
                            <div className="change-password input-group-text" style={{ cursor: "pointer" }} onClick={() => setConPass(!conPass)}>
                                <i className="fa fa-eye" />
                            </div>
                        </div>
                        <span className="text-danger font-weight-bold">
                            {simpleValidator.current.message("confirm password", input?.con_password, "required")}
                        </span>
                        {
                            input?.match_pass &&
                            <span className="text-danger font-weight-bold">
                                Confirm Password doesn't match with New Password.
                            </span>
                        }
                        {passLength?.conPass && <div className="text-danger fs-12">"Password must be minimum 6 characters"</div>}
                    </div>
                </div>
                <div className="col-lg-12 m-b10">
                    <button
                        className="site-button"
                        onClick={handleSubmit}
                    >
                        Update Password
                    </button>
                </div>
            </div>
        </div>
    )
}
export default Changepasswordpage;